import React, { FunctionComponent } from 'react'
import { reactular } from '@vendhq/reactular'
import { SaleProductSearch } from '../product/SaleProductSearch'
import { useQuickKeysManager } from '../../ng-compat/hooks'
import { QuickKeys } from '../quick-keys/QuickKeys'
import { AddProductToSaleModals } from '../AddProductToSale/AddProductToSaleModals'
import { TrainingModeModal } from '../../modals/TrainingModeModal'

export const Workspace: FunctionComponent = () => {
  const quickKeysManager = useQuickKeysManager()
  const quickKeysEnabled = quickKeysManager.isQuickKeysEnabled()

  return (
    <>
      <div className="wr-global-search">
        <SaleProductSearch />
      </div>
      {quickKeysEnabled ? (
        <div className="wr-workspace-module-container">
          <QuickKeys />
        </div>
      ) : null}
      <AddProductToSaleModals />
      {
        // TODO: Ideally this would be at the root of the sell screen but
        // that's basically a bunch of UI-views. Move it to a better place
        // when it exists.
      }
      <TrainingModeModal />
    </>
  )
}

export const WorkSpaceComponent = reactular(Workspace, [], 'reactWrapper')
